import cx from 'classnames';
import PropTypes from 'prop-types';

import { CheckmarkIcon } from 'src/assets/icons/Checkmark';
import { IconClose } from 'src/assets/icons/IconClose';
import { CUSTOM_TOOLTIP_SIZE, CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { formatByObject } from 'src/lib/format';

import useStyles from './useStyles';

export const PlanFeature = ({
  className,
  feature,
  textFormatObject,
  removed,
  plan,
  tier,
  billingCycle,
  hideTooltip,
  hideTooltipDashes,
  grayIcon,
}) => {
  const styles = useStyles();

  const { text, isHeader, tooltip = '' } = feature;
  const hideIcon = Boolean(isHeader);
  const finalText = typeof text === 'function' ? text({ plan, tier }) : text;
  const finalTooltip = typeof tooltip === 'function' ? tooltip({ billingCycle }) : tooltip;
  const textFormatted = formatByObject(finalText, textFormatObject);

  return (
    <CustomTooltip
      title={(!hideTooltip && finalTooltip) || ''}
      size={CUSTOM_TOOLTIP_SIZE.small}
      placement="top"
    >
      <div
        className={cx(styles.root, className, {
          [styles.header]: isHeader,
          [styles.dashed]: !hideTooltip && !hideTooltipDashes && Boolean(finalTooltip),
          [styles.grayIcon]: grayIcon,
        })}
      >
        {!hideIcon &&
          (removed ? (
            <IconClose className={styles.iconCross} />
          ) : (
            <CheckmarkIcon className={styles.iconCheck} />
          ))}

        <CustomTypography
          className={styles.text}
          variant={TYPOGRAPHY_VARIANT.paragraph14}
          dangerouslySetInnerHTML={{
            __html: textFormatted,
          }}
        />
      </div>
    </CustomTooltip>
  );
};

PlanFeature.propTypes = {
  className: PropTypes.string,
  feature: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
    isHeader: PropTypes.bool,
  }).isRequired,
  textFormatObject: PropTypes.shape(),
  removed: PropTypes.bool,
  plan: PropTypes.string,
  tier: PropTypes.string,
  billingCycle: PropTypes.string,
  hideTooltip: PropTypes.bool,
  hideTooltipDashes: PropTypes.bool,
  grayIcon: PropTypes.bool,
};

PlanFeature.defaultProps = {
  className: null,
  textFormatObject: null,
  removed: false,
  plan: null,
  tier: null,
  billingCycle: null,
  hideTooltip: false,
  hideTooltipDashes: false,
  grayIcon: false,
};
